import Select from 'Design/components/Select'
import React from 'react'
import toast from 'react-hot-toast'

import styles from './TrainingList.module.scss'
import { useUpdateReviewStatusMutation } from '../training.service'

import * as date from 'Utils/date'

export const SuggestionsShown = (props) => {
  const suggestions = props.cell.value || []

  return (
    <ul className={styles.SuggestionShownList}>
      {suggestions.map((suggestion) => {
        return <li key={'Suggestion' + suggestion.value}>{suggestion.text}</li>
      })}
    </ul>
  )
}

export const SuggestionSelectedByVisitor = (props) => {
  const value = props.cell.value || '-'
  return value
}

export const Feedback = (props) => {
  const feedback = props.cell.value?.value || '-'
  return <span className={styles.Capitalize}>{feedback.split('_').join(' ')}</span>
}

export const CreatedOn = (props) => {
  const value = props.cell.value
  return value ? date.formatRelativeDate(value, 7) : '-'
}

const REVIEW_STATUS = [
  { label: 'Pending', value: 'pending' },
  { label: 'Content Required', value: 'content_required' },
  { label: 'Training Required', value: 'training_required' },
  { label: 'Trained', value: 'trained' },
  { label: 'Ignore', value: 'ignore' }
]
export const ReviewStatus = (props) => {
  const reviewStatus = props.cell.value || ''
  const phrase = props.row.original

  const [updateReviewStatus] = useUpdateReviewStatusMutation()

  const handleChange = (e) => {
    const promise = updateReviewStatus({
      id: phrase.id,
      status: e.target.value
    }).unwrap()

    toast.promise(promise, {
      loading: 'Updating review status',
      success: 'Review status updated successfully',
      error: 'Failed to update review status. Try again...'
    })
  }

  return (
    <Select className={styles.ReviewStatus} value={reviewStatus} onChange={handleChange}>
      <option value='' disabled>
        Select
      </option>
      {REVIEW_STATUS.map((r) => {
        return (
          <option key={r.value} value={r.value}>
            {r.label}
          </option>
        )
      })}
    </Select>
  )
}
